export const INTERFACE_DENSITIES = ["normal", "compact", "ultra"] as const;

export type InterfaceDensity = (typeof INTERFACE_DENSITIES)[number];

export function normalizeInterfaceDensity(value: unknown): InterfaceDensity {
  return INTERFACE_DENSITIES.includes(value as InterfaceDensity)
    ? (value as InterfaceDensity)
    : "normal";
}
